import React, { useEffect, useState } from "react";
import "./PatientRegisterForm.css";
import {
  getProfileStatus,
  getOtp,
  validateOtp,
  GenerateOTPRegister,
  ValidateRegistedOtp,
  registeredPatient,
  ChangePwd,
  validateOTP,
} from "../../api/api";
import toast from "react-hot-toast";
import { formatDate } from "../../utils/helper";
import { Link, useNavigate } from "react-router-dom";

export default function PatientRegisterForm() {
  const [formData, setFormData] = useState({
    mobile: "",
    firstName: "",
    lastName: "",
    email: "",
    alternateMobile: "",
    gender: "M",
    address: "",
    landmark: "",
    state: "West Bengal",
    city: "Kolkata",
    pincode: "",
    dateofbirth: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpInput, setOtpInput] = useState("");
  const [timeLeft, setTimeLeft] = useState(0); // seconds
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [registeredUserId, setRegisteredUserId] = useState(null);
  const [showPasswordSetup, setShowPasswordSetup] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordLoading, setPasswordLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // watch mobile changes and trigger profile check when it becomes 10 digits
    if (
      formData?.mobile &&
      formData.mobile.toString().replace(/\D/g, "").length === 10
    ) {
      handleCheckProfile(formData.mobile);
    }
  }, [formData.mobile]);

  const handleCheckProfile = async (mobileNo) => {
    const mobileToUse = formData?.mobile;
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      user_id: "",
      mobile_no: mobileToUse,
    };

    try {
      setLoading(true);
      const res = await getProfileStatus(payload);
      const data = res?.data?.data || [];

      setProfileData(data);

      if (data?.length > 0) {
        setShowModal(true); // show modal when profile exists
      }
    } catch (error) {
      console.error("Error checking profile:", error);
    } finally {
      setLoading(false);
    }
  };

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "mobile":
        if (!value.trim()) error = "Mobile number is required.";
        else if (!/^\d{10}$/.test(value))
          error = "Enter a valid 10-digit mobile number.";
        break;

      case "firstName":
        if (!value.trim()) error = "First name is required.";
        else if (!/^[A-Za-z ]+$/.test(value))
          error = "Special characters or numbers are not allowed.";
        break;

      case "lastName":
        if (!value.trim()) error = "Last name is required.";
        else if (!/^[A-Za-z ]+$/.test(value))
          error = "Special characters or numbers are not allowed.";
        break;

      case "email":
        if (!value.trim()) error = "Email is required.";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          error = "Enter a valid email address.";
        break;

      case "alternateMobile":
        // if (!value.trim()) error = "Alternate number is required.";
        if (!/^\d{10}$/.test(value))
          error = "Enter a valid 10-digit alternate number.";
        break;

      case "gender":
        if (!value.trim()) error = "Gender is required.";
        break;

      case "dateofbirth":
        if (!value.trim()) error = "Date of Birth is required.";
        break;

      case "address":
        if (!value.trim()) error = "Address is required.";
        break;

      case "state":
        if (!value.trim()) error = "State is required.";
        break;

      case "city":
        if (!value.trim()) error = "City is required.";
        break;

      case "pincode":
        if (!value.trim()) error = "Pincode is required.";
        else if (!/^\d{6}$/.test(value))
          error = "Enter a valid 6-digit pincode.";
        break;

      default:
        break;
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    const error = validateField(name, value);
    setErrors((prev) => ({ ...prev, [name]: error }));

    if (!error) {
      setTimeout(() => {
        setErrors((prev) => ({ ...prev, [name]: "" }));
      }, 5000);
    }
    // clear otp and verification state if user changes email or mobile
    if (name === "email" || name === "mobile") {
      setOtpSent(false);
      setIsOtpVerified(false);
    }
  };

  const handleSendOtp = async () => {
    // only allow if email is valid
    const emailError = validateField("email", formData.email);
    if (emailError) {
      toast.error("Please enter a valid email to enable OTP.");
      return;
    }

    // const mobile = (formData.mobile || "").toString().replace(/\D/g, "");
    // if (!/^\d{10}$/.test(mobile)) {
    //   toast.error("Enter a valid 10-digit mobile number to receive OTP.");
    //   return;
    // }

    try {
      setOtpLoading(true);
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        mobile_no: formData?.mobile,
      };
      const res = await getOtp(payload);
      console.log("OTP send response:", res);
      setOtpSent(true);
      // open OTP modal and start countdown (2 minutes)
      setShowOtpModal(true);
      setTimeLeft(600);
      setOtpInput("");
      setIsOtpVerified(false);
      toast.success("OTP sent to mobile number.");
    } catch (err) {
      console.error("Error sending OTP:", err);
      toast.error("Failed to send OTP. Try again.");
    } finally {
      setOtpLoading(false);
    }
  };

  // countdown timer for OTP modal
  React.useEffect(() => {
    if (!showOtpModal || timeLeft <= 0) return;
    const t = setInterval(() => {
      setTimeLeft((s) => {
        if (s <= 1) {
          clearInterval(t);
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [showOtpModal, timeLeft]);

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60)
      .toString()
      .padStart(1, "0");
    const s = (sec % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handlePasswordChange = async () => {
    try {
      setPasswordLoading(true);
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        Mobile_no: formData?.mobile,
        Password: newPassword,
        Pat_status: "1",
      };

      const res = await ChangePwd(payload);
      console.log("Change password response:", res);

      if (res?.data?.status === "success") {
        toast.success("Password set successfully!");
        setShowPasswordSetup(false);
        navigate("/users/login");
      } else {
        toast.error(res?.data?.message || "Failed to set password.");
      }
    } catch (err) {
      console.error("Error setting password:", err);
      toast.error("Error while setting password.");
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otpInput || otpInput.toString().length < 4) {
      toast.error("Enter the 4-digit OTP.");
      return;
    }
    try {
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: registeredUserId,
        otp: otpInput,
        Reg_status: "1",
      };
      const res = await validateOTP(payload);
      console.log("Validate OTP res:", res);
      if (res?.data?.status === "success") {
        toast.success("OTP verified successfully.");
        setShowOtpModal(false);
        setOtpSent(false);
        setTimeLeft(0);
        setIsOtpVerified(true);
        // proceed with registration or next step as required
        await handlePasswordChange();
      } else {
        toast.error("OTP verification failed. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("OTP verification failed. Please try again.");
    }
  };

  const handleCancelOtp = () => {
    setShowOtpModal(false);
    setOtpSent(false);
    setOtpInput("");
    setTimeLeft(0);
    setIsOtpVerified(false);
  };

  const handleResendOtp = async () => {
    // allow resend even if timer>0 but disable resend during send
    await handleSendOtp();
  };

  const handleRegisteredPatient = async (e) => {
    e.preventDefault();
    let newErrors = {};
    requiredFields.forEach((field) => {
      const val = formData[field] || "";
      const err = validateField(field, val);
      if (err) newErrors[field] = err;
    });

    // If ANY error exists → stop submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fill all required fields correctly.");
      return;
    }

    // If OTP not verified, stop submission
    // if (!isOtpVerified) {
    //   toast.error("Please verify OTP first.");
    //   return;
    // }
    try {
      const current = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const date = `${pad(current.getDate())}-${pad(
        current.getMonth() + 1
      )}-${current.getFullYear()}`;
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: "",
        FName: formData?.firstName,
        LName: formData?.lastName,
        Email: formData?.email,
        Mobile_no: formData?.mobile,
        Alt_mobile_no: formData?.alternateMobile,
        Address: formData?.address,
        Landmark: formData?.landmark,
        ZipCode: formData?.pincode,
        City: formData?.city,
        State: formData?.state,
        Reg_status: "0",
        Pat_status: "0",
        IsMobileregister: "",
        Registerdate: date,
        PTitle: "",
        Gender: formData?.gender,
        Dateofbirth: formatDate(formData?.dateofbirth),
        channel: "A",
        PatType: "P",
      };
      const response = await registeredPatient(payload);
      console.log("Registration response:", response);

      //   try to extract a user id from the response (different backends return different keys)
      const maybeData = response?.data || {};
      const userId = maybeData?.user_id || null;

      if (userId) {
        setRegisteredUserId(userId);
        setShowPasswordSetup(true);
        toast.success("Registered successfully. Please set a password.");

        return;
      }

      // if no user id found but API reported success, still allow password setup using mobile
      if (
        response?.data?.status === "success" ||
        response?.data?.status?.toLowerCase?.() === "success"
      ) {
        setShowPasswordSetup(true);
        toast.success("Registered successfully. Please set a password.");
        return;
      }
    } catch (err) {
      console.error("error is", err);
    }
  };

  const handleSetPassword = async (e) => {
    e.preventDefault && e.preventDefault();

    if (!newPassword || newPassword.trim() === "") {
      toast.error("Password cannot be empty");
      return;
    }
    if (newPassword.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    await handleSendOtp();
  };

  // required fields (alternateMobile and landmark are optional)
  const requiredFields = [
    "mobile",
    "firstName",
    "lastName",
    "email",
    "address",
    "state",
    "city",
    "pincode",
    "gender",
    "dateofbirth",
  ];

  const isFormComplete = () => {
    for (const f of requiredFields) {
      const val = formData[f] || "";
      const err = validateField(f, val);
      if (err) return false;
    }
    return true;
  };

  return (
    <div className="form-container">
      {!showPasswordSetup ? (
        <form className="patient-form" onSubmit={handleRegisteredPatient}>
          <div className="register-form-row full-width">
            <div className="col">
              <input
                type="tel"
                name="mobile"
                placeholder="Mobile Number*"
                value={formData.mobile}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  handleChange({
                    target: { name: "mobile", value },
                  });
                }}
                autoComplete="off"
                maxLength={10}
              />
              {errors.mobile && (
                <p style={{ color: "red", fontSize: "0.8rem" }}>
                  {errors.mobile}
                </p>
              )}
            </div>
          </div>

          <div className="register-form-row">
            <div>
              <input
                type="text"
                name="firstName"
                placeholder="First Name*"
                value={formData.firstName}
                onChange={handleChange}
                autoComplete="off"
              />
              {errors.firstName && (
                <p style={{ color: "red", fontSize: "0.8rem" }}>
                  {errors.firstName}
                </p>
              )}
            </div>

            <div>
              <input
                type="text"
                name="lastName"
                placeholder="Last Name*"
                value={formData.lastName}
                onChange={handleChange}
                autoComplete="off"
              />
              {errors.lastName && (
                <p style={{ color: "red", fontSize: "0.8rem" }}>
                  {errors.lastName}
                </p>
              )}
            </div>
            <div>
              <input
                type="date"
                name="dateofbirth"
                placeholder="Date of Birth*"
                value={formData.dateofbirth}
                onChange={handleChange}
                autoComplete="off"
                max={new Date().toISOString().split("T")[0]}
              />
              {errors.dateofbirth && (
                <p style={{ color: "red", fontSize: "0.8rem" }}>
                  {errors.dateofbirth}
                </p>
              )}
            </div>
          </div>

          <div className="register-form-row align-start EAG-1364">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.35rem",
                flex: 1,
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="Email*"
                value={formData.email}
                onChange={handleChange}
                autoComplete="off"
              />
              {/* Show Send OTP button when email is valid */}
              {/* { !validateField('email', formData.email) && formData.email && !isOtpVerified && (
                <div style={{ marginTop: 4 }}>
                  <button
                    type="button"
                    className="rbdButton"
                    onClick={handleSendOtp}
                    disabled={otpLoading || otpSent}
                  >
                    {otpLoading ? 'Sending...' : (otpSent ? 'OTP Sent' : 'Send OTP')}
                  </button>
                </div>
              )} */}
              {errors?.email && (
                <p style={{ color: "red", fontSize: "0.8rem" }}>
                  {errors.email}
                </p>
              )}
            </div>
            <div>
              <input
                type="text"
                name="alternateMobile"
                placeholder="Alternate Mobile No(Optional)"
                value={formData.alternateMobile}
                onChange={handleChange}
                autoComplete="off"
              />
              {errors.alternateMobile && (
                <p tyle={{ color: "red", fontSize: "0.8rem" }}>
                  {errors.alternateMobile}
                </p>
              )}
            </div>

            <div className="gender-block">
              <label className="gender-label">Gender*</label>
              <div className="gender-options">
                <label>
                  <input
                    type="radio"
                    name="gender"
                    value="M"
                    checked={formData.gender === "M"}
                    onChange={handleChange}
                  />{" "}
                  Male
                </label>
                <label>
                  <input
                    type="radio"
                    name="gender"
                    value="F"
                    checked={formData.gender === "F"}
                    onChange={handleChange}
                  />{" "}
                  Female
                </label>
              </div>
              {errors.gender && (
                <p style={{ color: "red", fontSize: "0.8rem" }}>
                  {errors.gender}
                </p>
              )}
            </div>
          </div>

          <div className="register-form-row full-width">
            <textarea
              name="address"
              placeholder="Address*"
              value={formData.address}
              onChange={handleChange}
              autoComplete="off"
            />
            {errors.address && (
              <p style={{ color: "red", fontSize: "0.8rem" }}>
                {errors.address}
              </p>
            )}
          </div>

          <div className="register-form-row full-width">
            <input
              type="text"
              name="landmark"
              placeholder="Landmark"
              value={formData.landmark}
              onChange={handleChange}
              autoComplete="off"
            />
          </div>

          <div className="register-form-row">
            <div>
              <input
                type="text"
                name="state"
                placeholder="State*"
                value={formData.state}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>
            <div>
              <input
                type="text"
                name="city"
                placeholder="City*"
                value={formData.city}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>

            <div>
              <input
                type="text"
                name="pincode"
                placeholder="Pincode*"
                value={formData.pincode}
                onChange={handleChange}
                autoComplete="off"
              />
              {errors.pincode && (
                <p style={{ color: "red", fontSize: "0.8rem" }}>
                  {errors.pincode}
                </p>
              )}
            </div>
          </div>

          <div className="register-form-row full-width">
            <button
              type="submit"
              className="submit-btn rbdButton"
              // disabled={!isFormComplete()}
            >
              <span className="btn-text">Register</span>
            </button>
          </div>

          <div className="form-footer">
            <p>
              Already Registered? <Link to="/users/login">Login now</Link>
            </p>
          </div>
        </form>
      ) : (
        <div
          className="patient-form"
          style={{ maxWidth: 520, margin: "0 auto" }}
        >
          {/* <h3 style={{ color: "#2ec1c5", textAlign: "center" }}>
            Set Password
          </h3> */}
          <p style={{ textAlign: "center", color: "#666" }}>
            {registeredUserId ? (
              <>
                Account created. Please set a password for user id{" "}
                <strong>{registeredUserId}</strong>.
              </>
            ) : (
              <>
                Account created. Please set a password for{" "}
                <strong>{formData.mobile}</strong>.
              </>
            )}
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <input
              type="password"
              name="newPassword"
              placeholder="New Password*"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password*"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button
              type="button"
              className="submit-btn rbdButton"
              onClick={handleSetPassword}
              disabled={passwordLoading}
            >
              <span className="btn-text">
                {passwordLoading ? "Updating..." : "SUBMIT"}
              </span>
            </button>
          </div>
          <div className="form-footer" style={{ marginTop: 12 }}>
            <p>
              Already Registered? <a href="/users/login">login now</a>
            </p>
          </div>
        </div>
      )}
      {showModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
              width: "450px",
              padding: "30px",
              textAlign: "center",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            <h3
              style={{
                color: "#2ec1c5",
                marginBottom: "15px",
                textAlign: "center",
              }}
            >
              Alert
            </h3>
            <p style={{ color: "#555", marginBottom: "25px" }}>
              Mobile No is already registered. Please login.
            </p>
            <div
              style={{ display: "flex", justifyContent: "center", gap: "15px" }}
            >
              <button
                style={{
                  background: "#2ec1c5",
                  color: "white",
                  padding: "6px 16px",
                  borderRadius: "6px",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={() => (window.location.href = "/users/login")}
              >
                Login
              </button>
              <button
                style={{
                  background: "white",
                  color: "#2ec1c5",
                  padding: "6px 16px",
                  borderRadius: "6px",
                  border: "1px solid #2ec1c5",
                  cursor: "pointer",
                }}
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showOtpModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1100,
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "20px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.35)",
              width: "600px",
              padding: "22px",
              textAlign: "left",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            <h2 style={{ color: "#2ec1c5", margin: 0, marginBottom: 14 }}>
              OTP Verification
            </h2>
            <hr style={{ width: "100%", color: "lightgray" }} />

            <label style={{ color: "#2ec1c5", fontWeight: 600 }}>
              OTP<span style={{ color: "#d93025" }}> *</span>
            </label>
            <input
              type="text"
              value={otpInput}
              onChange={(e) => setOtpInput(e.target.value.replace(/\D/g, ""))}
              placeholder="Enter OTP"
              maxLength={4}
              style={{
                width: "95%",
                padding: 10,
                marginTop: 6,
                marginBottom: 10,
                borderRadius: 4,
                border: "1px solid #ccc",
              }}
            />

            <div
              style={{ textAlign: "center", color: "#666", marginBottom: 14 }}
            >
              {formatTime(timeLeft)}
            </div>

            <div style={{ display: "flex", gap: 16, justifyContent: "center" }}>
              <button
                type="button"
                onClick={handleResendOtp}
                disabled={otpLoading}
                style={{
                  background: "#2ec1c5",
                  color: "white",
                  padding: "10px 26px",
                  borderRadius: 6,
                  border: "none",
                  cursor: otpLoading ? "not-allowed" : "pointer",
                }}
              >
                {otpLoading ? "Resending..." : "Resend"}
              </button>

              <button
                type="button"
                onClick={handleVerifyOtp}
                style={{
                  background: "#1976d2",
                  color: "white",
                  padding: "10px 26px",
                  borderRadius: 6,
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Verify
              </button>

              <button
                type="button"
                onClick={handleCancelOtp}
                style={{
                  background: "white",
                  color: "#2ec1c5",
                  padding: "10px 26px",
                  borderRadius: 6,
                  border: "1px solid #2ec1c5",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
